import { render, staticRenderFns } from "./inStorage.vue?vue&type=template&id=0e1b0bca&scoped=true&"
import script from "./inStorage.vue?vue&type=script&lang=js&"
export * from "./inStorage.vue?vue&type=script&lang=js&"
import style0 from "./inStorage.vue?vue&type=style&index=0&id=0e1b0bca&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e1b0bca",
  null
  
)

export default component.exports